<agpr-dialog-container
    [heading]="!!user?.id  ? 'UMT.profile.dialog.header.edit' : 'UMT.profile.dialog.header.create'"
    (close)="closeDialog()"
>
    <agpr-scroll-panel>
        <agpr-user-profile
            #userProfile
            [agprLoading]="loading"
            [user]="user"
        >
        </agpr-user-profile>
    </agpr-scroll-panel>

    <ng-template #footerLeft>
        <agpr-button
            label="cancel"
            [disabled]="loading"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        @if(user?.id ) {
            <ng-container
                *ngTemplateOutlet="userProfile.actionButton"
            ></ng-container>
        }
        <agpr-button
            [style]="buttonTypesEnum.primary"
            [label]="!!user?.id ? 'update' : 'create'"
            [disabled]="loading || !user.isActive || !user.isFormValid()"
            (click)="saveUser()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
